import React, { useState, useEffect } from "react";
import { history } from "../../helpers";
import { dealjacketActions, orgActions } from "../../actions";
import { OrgDropdown } from "../org/OrgDropdown";
import { connect } from "react-redux";
import { Mixpanel } from "../../helpers";

function SearchInput(props) {
  // mixpanel.init('63b6a2e8025111485769d28bc9ad5c48', {debug: true}); 
  const magnifying_glass = require("../../images/magnifying-glass.png").default;

  const { dealjackets, org, authentication, clearSearch, getDocTypes } = props;
  const orgs = authentication?.user?.orgs;
  const user_id = authentication?.user?.user_id;

  const org_id = Number(org.current_org_id);
  const user_orgs = authentication.user.orgs;
  const current_org = user_orgs.filter(
    (org) => org.org_id === org_id
  )[0];

  const use_doctypes = current_org.allow_doc_types;
  const user_doctypes = authentication?.user?.doctypes.filter(doctype => doctype.org_id === current_org.org_id);
  const org_doctypes = org?.doc_types;

  const doctypes = (user_doctypes?.length > 0) ? user_doctypes?.map((doctype) => doctype.doc_type_name) : org_doctypes?.map((doctype) => doctype.doc_type_name);

  const old_search_term = dealjackets?.searchResults?.search_term;
  const old_doctype = dealjackets?.searchResults?.doctype;
  const [searchTerm, setSearchTerm] = useState(old_search_term ? old_search_term : "");
  const [selectedDocType, setSelectedDocType] = useState(old_doctype ? old_doctype : "All");

  useEffect(() => {
    if (!use_doctypes) {
      setSelectedDocType("All");
    }
  }, [org_id])

  useEffect(() => {
    if (use_doctypes) {
      getDocTypes(org_id);
    }
  }, [org_id])

  function handleInputChange(e) {
    const { value } = e.target;
    setSearchTerm(value);
    props.searchRequestViolation(false);
  }


  function handleSubmit(e) {
    e.preventDefault();

    if (searchTerm && searchTerm.length >= 3) {
      const queryString = "q=All&t=" + searchTerm + "&l=50&d=" + selectedDocType;

      const custom_properties = {
        'tt_user_id': user_id,
        'tt_org_id': org_id,
        'tt_search_term': searchTerm,
        'tt_doc_type': selectedDocType
      };

      Mixpanel.track('Search', custom_properties);
      // clearSearch();
      history.push("/org/" + org_id + "/dealjackets?" + queryString);
    } else {
      props.searchRequestViolation(true);
    }


  }

  function handleEnterKey(e) {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  }

  function userIsMultiOrg() {
    return orgs?.length > 1;
  }

  const onChangeDocType = (e) => {
    const new_doctype = e.target.value;
    setSelectedDocType(new_doctype);
    if (searchTerm && searchTerm.length >= 3) {
      const queryString = "q=All&t=" + searchTerm + "&l=50&d=" + new_doctype;

      const custom_properties = {
        'tt_user_id': user_id,
        'tt_org_id': org_id,
        'tt_search_term': searchTerm,
        'tt_doc_type': e.target.value
      };

      Mixpanel.track('Search', custom_properties);
      clearSearch();
      history.push("/org/" + org_id + "/dealjackets?" + queryString);
    } else {
      props.searchRequestViolation(true);
    }
  }


  const doctypes_html = doctypes?.map((doctype, i) => (
    <>
      <option key={i} id="doctype" name="doctypes" value={doctype}>
        {doctype}
      </option>
    </>
  ));

  return (
    <>
      <div className="searchInput">
        <div id="searchTopLine">
          <span className="searchHeader">Search for {use_doctypes ? "Files" : "Deals"}</span>

        </div>

        {userIsMultiOrg() && (
          <span className="searchSubHeader">search store:</span>
        )}
        <div className="searchInputWrapper">
          {userIsMultiOrg() && (
            <div>
              <OrgDropdown />
            </div>
          )}
          <div className={`inputBoxWrapper ${userIsMultiOrg() ? "multiOrg" : "singleOrg"}`}>
            <input
              className="searchInputBox"
              type="text"
              id="search-input"
              onChange={handleInputChange}
              onKeyPress={handleEnterKey}
              minLength="3"
              value={searchTerm}
            />
          </div>
          <div className="searchButton" onClick={handleSubmit}>
            {
              <img
                src={magnifying_glass}
                className="searchImage"
                width="24px"
                align="center"
                alt="search"
              />
            }
          </div>
        </div>
        {(use_doctypes) &&
          <>
            <div className="searchInputWrapper">
              <span className="searchSubHeader">filter results by doctype:</span>
            </div>
            <div className="searchInputWrapper">
              <select className="doctypeDropdown"
                value={selectedDocType}
                onChange={(e) => onChangeDocType(e)}
              >
                <option key="All" id="doctype" name="doctypes" value="All">
                  All
                </option>
                {doctypes_html}
              </select>
            </div>
          </>
        }

        {dealjackets.search_request_violation && <div><br /><span className="searcherrormessage">Please enter at least 3 characters</span></div>}
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { dealjackets, authentication, org } = state;
  return {
    dealjackets,
    authentication,
    org
  };
}

const actionCreators = {
  search: dealjacketActions.search,
  searchRequestViolation: dealjacketActions.searchRequestViolation,
  clearSearch: dealjacketActions.clearSearch,
  getDocTypes: orgActions.getDocTypes
};

const connectedSearchInput = connect(
  mapStateToProps,
  actionCreators
)(SearchInput);
export { connectedSearchInput as SearchInput };
